import React, {createContext, useContext, useState} from 'react'
import PropTypes from 'prop-types'
import {StorefrontPreview} from '@salesforce/commerce-sdk-react/components'

const PreviewContext = createContext()

export const StorefrontPreviewProvider = ({children, ...previewProps}) => {
    const [previewData, setPreviewData] = useState({})

    const onPreviewContextChange = (context) => {
        const {effectiveDateTime, customerGroupIds, sourceCode} = context || {}
        const newPreviewDate = {}
        let formattedDate = ''
        if (effectiveDateTime) {
            const newDate = new Date(effectiveDateTime)
            formattedDate =
                newDate.getFullYear().toString() +
                String(newDate.getMonth() + 1).padStart(2, '0') +
                String(newDate.getDate()).padStart(2, '0') +
                String(newDate.getHours()).padStart(2, '0') +
                String(newDate.getMinutes()).padStart(2, '0')
        }

        setPreviewData({
            __siteDate: formattedDate,
            __sourceCode: sourceCode || '',
            __customerGroup: customerGroupIds || ''
        })
    }
    const value = {
        onPreviewContextChange: onPreviewContextChange,
        previewData: previewData
    }
    return (
        <PreviewContext.Provider value={value}>
            <StorefrontPreview onContextChange={onPreviewContextChange} {...previewProps}>
                {children}
            </StorefrontPreview>
        </PreviewContext.Provider>
    )
}

StorefrontPreviewProvider.propTypes = {
    children: PropTypes.any
}

/**
 * A hook for managing preview state and actions
 * @returns {Object} preview data and actions
 */
export const usePreview = () => {
    return useContext(PreviewContext)
}
